module.exports = __webpack_public_path__ + "static/media/code_quest_4.1c3f9c78.jpeg";